import React from 'react';
import Icon from '../../../Symbols/Icon';
const IconClose = ({ size, fill, ...commonProps }) => {
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M18.5303 18.5302C18.8228 18.2377 18.8228 17.7622 18.5303 17.4697L13.0605 11.9999L18.5303 6.53019C18.8228 6.23694 18.8228 5.76219 18.5303 5.46969C18.2378 5.17719 17.7623 5.17644 17.4698 5.46969L12 10.9394L6.53025 5.46969C6.237 5.17644 5.76225 5.17644 5.46975 5.46969C5.17725 5.76294 5.1765 6.23769 5.46975 6.53019L10.9395 11.9999L5.46975 17.4697C5.1765 17.7622 5.1765 18.2377 5.46975 18.5302C5.763 18.8227 6.23775 18.8227 6.53025 18.5302L12 13.0604L17.4698 18.5302C17.7623 18.8227 18.2378 18.8227 18.5303 18.5302Z", fill: "black" }))),
        alt: 'Close',
    };
    return React.createElement(Icon, { ...commonProps, source: iconContent, size: size, fill: fill });
};
IconClose.displayName = 'IconClose';
export default IconClose;
//# sourceMappingURL=index.js.map